import type { QueryClient } from '@tanstack/react-query';
import { isRedirect, redirect } from '@tanstack/react-router';
import { getScenarioQueryOptions } from '@/lib/queries/loop-planner/useGetScenario';
import { isHttpError } from '@/lib/utils/common/isHttpError';

export const ensureScenarioOrRedirect = async ({
  loopId,
  scenarioId,
  org,
  queryClient,
}: {
  loopId: number;
  scenarioId: number;
  org: string;
  queryClient: QueryClient;
}) => {
  try {
    await queryClient.ensureQueryData(getScenarioQueryOptions({ loopId, scenarioId }));
  } catch (error) {
    if (isRedirect(error)) {
      throw error;
    }
    if (isHttpError(error, 404)) {
      throw redirect({
        to: '/org/$org/loop/$loopId/planner',
        params: { org, loopId },
      });
    }
    throw error;
  }
};
